import { buildURL } from "app/client/lib/urlUtils";
import * as css from "app/client/ui/LoginPagesCss";
import { theme } from "app/client/ui2018/cssVars";
import { getPageTitleSuffix } from "app/common/gristUrls";
import { getGristConfig } from "app/common/urlUtils";

import { Disposable, makeTestId, styled } from "grainjs";

const testId = makeTestId("test-evp-");

export class EmailVerifiedPage extends Disposable {
  public buildDom() {
    const suffix = getPageTitleSuffix(getGristConfig());
    document.title = `Email verified${suffix}`;

    return cssScrollablePage(cssContent(
      css.flexJustifyCenter(css.gristLogo()),
      cssHeading("Email is verified!", testId("heading")),
      cssText("Please, sign in to continue using Grist."),
      css.bigPrimaryButtonLink(
        "Sign in to Grist",
        { href: buildURL("/login").href },
        testId("sign-in"),
      ),
      testId("content"),
    ));
  }
}

const cssScrollablePage = styled("div", `
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: ${theme.loginPageBg};
`);

const cssContent = styled("div", `
  text-align: center;
  margin: 240px 0 64px;
`);

const cssHeading = styled(css.formHeading, `
  text-align: center;
  margin-top: 24px;
`);

const cssText = styled(css.text, `
  margin: 0 auto 32px auto;
  max-width: 400px;
  text-align: center;
`);
